import {fork} from 'redux-saga/effects'
import getUserSaga from './userSaga'
import getContactSaga from './contactSaga'
import getContactListSaga from './contactListSaga'
import getDirtySaga from './dirtySaga'
import getDataSaga from './dataSaga'
import getDeliveriesSaga from './deliveriesSaga'
import getDialogSaga from './dialogSaga'
import getEmailingSaga from './emailingSaga'
import getFieldsSaga from './fieldsSaga'
import getQuotingSaga from './quotingSaga'
import getPriceListsSaga from './priceListsSaga'
import getPartCategoryTreeSelectField from './partCategoryTreeSelectFieldSaga'
import getSettingsSaga from './settingsSaga'
import getDiarySaga from './diarySaga'
import getPersistanceSaga from './persistanceSaga'
import getConfigSaga from './configSaga'
import getNotificationSaga from './notificationSaga'
import getUserFieldSaga from './userFieldSaga'
import getIntegrationSaga from './integrationSaga'
import getSearchSaga from './searchSaga'
import getInvoicingSaga from './invoicingSaga'
import getAccountingSaga from './accountingSaga'
import getAccountSaga from './accountSaga'
import getOnboardingSaga from './onboardingSaga'
import getProductionSaga from './productionSaga'
import getPurchasingSaga from './purchasingSaga'
import getNavigationSaga from './navigationSaga'
import getOpportunitySaga from './opportunitySaga'
import getPrintTemplateSaga from './printTemplateSaga'
import getLayoutSaga from './layoutsSaga'
import getSubscriptionSaga from './subscriptionSaga'
import getLanguageSaga from './languageSaga'
import getSocketSaga from './socketSaga'
import getDepartmentSaga from './departmentSaga'
import getCustomerSaga from './customerSaga'
import getPricingCalculatorSaga from './pricingCalculatorSaga'
import {api} from 'services/api'

export default function* root() {
  const notificationSaga = getNotificationSaga(api)
  const integrationSaga = getIntegrationSaga(api)

  yield fork(getUserSaga(api).watcher)
  yield fork(getContactSaga(api).watcher)
  yield fork(getContactListSaga(api).watcher)
  yield fork(getDirtySaga(api).watcher)
  yield fork(getDataSaga(api).watcher)
  yield fork(getDeliveriesSaga(api).watcher)
  yield fork(getEmailingSaga(api).watcher)
  yield fork(getFieldsSaga(api).watcher)
  yield fork(getQuotingSaga(api).watcher)
  yield fork(getPriceListsSaga(api).watcher)
  yield fork(getPartCategoryTreeSelectField(api).watcher)
  yield fork(getSettingsSaga(api).watcher)
  yield fork(getDialogSaga(api).watcher)
  yield fork(getPersistanceSaga(api).watcher)
  yield fork(getConfigSaga(api).watcher)
  yield fork(notificationSaga.watcher)
  yield fork(getUserFieldSaga(api).watcher)
  yield fork(getDiarySaga(api).watcher)
  yield fork(getSearchSaga(api).watcher)
  // save the state once loaded
  yield fork(getPersistanceSaga(api).stateWatcher)
  yield fork(integrationSaga.watcher)
  yield fork(integrationSaga.zohoWatcher)
  yield fork(getInvoicingSaga(api).watcher)
  yield fork(getAccountingSaga(api).watcher)
  yield fork(getAccountSaga(api).watcher)
  yield fork(getOnboardingSaga(api).watcher)
  yield fork(getProductionSaga(api).watcher)
  yield fork(getPurchasingSaga(api).watcher)
  yield fork(getNavigationSaga(api).watcher)
  yield fork(getOpportunitySaga(api).watcher)
  yield fork(getPrintTemplateSaga(api).watcher)
  yield fork(getLayoutSaga(api).watcher)
  yield fork(getSubscriptionSaga(api).watcher)
  yield fork(getLanguageSaga(api).watcher)
  yield fork(getSocketSaga(api).watcher)
  yield fork(getDepartmentSaga(api).watcher)
  yield fork(getCustomerSaga(api).watcher)
  yield fork(getPricingCalculatorSaga(api).watcher)
}
